
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';

@Component({
  components: {
    Viewer,
  },
})
export default class SfPhotosField extends Vue {
  val: any = [];

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  value!: any;

  @Watch('value')
  watchValue() {
    if (this.value == null) {
      this.val = [];
      return;
    }
    this.val = this.value;
  }

  mounted() {
    this.watchValue();
  }
}
